<div class="linked-sites-container">
  <div class="top-row">
    <h2>
      {{ CONSTANTS.TOP_LEFT_TEXT }}
    </h2>
    @if (group) {
      <h2>{{ CONSTANTS.TOP_RIGHT_TEXT }} {{ group.code }}</h2>
    }
  </div>

  @if (!group && !isEditMode && !isTextChanged) {
    <div class="description">
      {{ CONSTANTS.DESCRIPTIONS }}
    </div>
  }
  <!-- Current Site Table -->
  <div class="current-site-table">
    <table mat-table matSort [dataSource]="dataSource">
      <!-- Group -->
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef id="group-headers">
          <ion-row class="th-text"> {{ COLUMNTEXT.GROUP }}</ion-row>
        </th>
        <td
          mat-cell
          *matCellDef="let location; let i = index"
          headers="group-headers"
        >
          <ion-item
            class="custom-input-item"
            [ngClass]="{ 'focus-border': activeTextBox === 'code' }"
            lines="none"
          >
            <ion-input
              #input
              class="input-control"
              [(ngModel)]="location.code"
              maxlength="10"
              (ionFocus)="activeTextBox = 'code'"
              (ionBlur)="activeTextBox = ''"
              (ngModelChange)="onCodeChange($event)"
              (keypress)="preventSpecialCharacters($event)"
              [clearInput]="false"
            ></ion-input>
            @if (location?.code) {
              <ion-button
                slot="end"
                fill="clear"
                class="clear-btn"
                (click)="clearText('code', i); $event.stopPropagation()"
                (keydown.enter)="clearText('code', i)"
                aria-label="Clear code"
              >
                <img
                  class="clear-search-text-icons"
                  alt=""
                  [src]="IMAGES.CLEAR"
                />
              </ion-button>
            }
          </ion-item>
        </td>
      </ng-container>

      <!-- Description -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef id="description-headers">
          <ion-row class="th-text"> {{ COLUMNTEXT.NAME_OR_DESC }}</ion-row>
        </th>

        <td
          mat-cell
          *matCellDef="let location; let i = index"
          headers="description-headers"
        >
          <ion-item
            class="custom-input-item"
            [ngClass]="{ 'focus-border': activeTextBox === 'name' }"
            [lines]="'none'"
          >
            <ion-input
              class="input-control"
              #descriptionModel="ngModel"
              maxlength="30"
              [(ngModel)]="location.name"
              (ionFocus)="activeTextBox = 'name'"
              (ionBlur)="activeTextBox = ''"
              (keypress)="preventSpecialCharacters($event)"
              (ngModelChange)="onNameChange($event)"
              [clearInput]="false"
              (keypress)="
                commonUtils.preventSpecialCharacters(
                  $event,
                  SpecialCharacters.ALPHABET_NUMBER
                )
              "
            ></ion-input>
            @if (location?.name) {
              <ion-button
                slot="end"
                fill="clear"
                class="clear-btn"
                (click)="clearText('name', i); $event.stopPropagation()"
                (keydown.enter)="clearText('name', i)"
                aria-label="Clear description"
              >
                <img
                  class="clear-search-text-icons"
                  alt=""
                  [src]="IMAGES.CLEAR"
                />
              </ion-button>
            }
          </ion-item>
        </td>
      </ng-container>

      <!-- Number of Sites. -->
      <ng-container matColumnDef="numberOfSites">
        <th mat-header-cell *matHeaderCellDef id="noOfSites-headers">
          <ion-row class="th-text"> {{ COLUMNTEXT.NUMBER_OF_SITES }}</ion-row>
        </th>

        <td
          mat-cell
          *matCellDef="let location"
          headers="noOfSites-headers"
          class="padding-left"
        >
          {{ location?.numberOfSites }}
        </td>
      </ng-container>

      <!-- Action -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="action-header">
          <ion-row class="th-text center"> {{ COLUMNTEXT.ACTION }} </ion-row>
        </th>
        <td
          mat-cell
          *matCellDef="let location; let i = index"
          headers="action-headers"
          class="action-btn-container"
        >
          <!-- SAVE -->
          <ion-button
            class="btn"
            fill="clear"
            expand="full"
            [disabled]="!isTextChanged || isUndoing"
            (click)="save(location)"
          >
            <ion-icon
              class="icon"
              slot="icon-only"
              [src]="
                !isTextChanged || isUndoing
                  ? IMAGES.CHECK_CIRCLE_OUTLINE_GREY
                  : IMAGES.CHECK_CIRCLE_OUTLINE
              "
            ></ion-icon>
          </ion-button>

          <!-- UNDO -->
          <ion-button
            class="btn"
            fill="clear"
            expand="full"
            [disabled]="!isTextChanged || isUndoing"
            (click)="undo()"
          >
            <ion-icon
              class="icon"
              slot="icon-only"
              [src]="
                !isTextChanged || isUndoing
                  ? IMAGES.REFRESH_OUTLINE_GREY
                  : IMAGES.REFRESH_OUTLINE
              "
            ></ion-icon>
          </ion-button>

          @if (!group.linkedSites.length) {
            <ion-button
              class="btn"
              fill="clear"
              expand="full"
              [disabled]="isDeleteDisabled"
              (click)="onDelete(location.code, i)"
            >
              <ion-icon
                class="icon"
                slot="icon-only"
                [src]="
                  isDeleteDisabled ? IMAGES.DELETE_INACTIVE : IMAGES.DELETE
                "
              ></ion-icon>
            </ion-button>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="DISPLAYED_COLS" sticky="true"></tr>

      <tr
        mat-row
        *matRowDef="let row; columns: DISPLAYED_COLS; let i = index"
      ></tr>

      <tr *matNoDataRow>
        <td [attr.colspan]="DISPLAYED_COLS.length">
          <app-no-results-found></app-no-results-found>
        </td>
      </tr>
    </table>
  </div>
  <!------------------------>

  <!-- Linked Sites Table -->
  <div
    class="linked-site-table"
    [ngClass]="{ 'no-result': !linkedSiteDataSource.data.length }"
  >
    <table mat-table matSort [dataSource]="linkedSiteDataSource">
      <!-- Sites -->
      <ng-container matColumnDef="sites">
        <th mat-header-cell *matHeaderCellDef id="sites-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.LINKED_SITES"
            [control]="sitesData.formControl"
            [maxLength]="20"
            [placeholder]="CONSTANTS.SEARCH_SITES_PLACEHOLDER"
            [allowedSpecialChars]="SpecialCharacters.ALPHABET_NUMBER_NO_SPACE"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>
        <td mat-cell *matCellDef="let location" headers="sites-headers">
          <div>
            <a class="hyperlink" (click)="locationProfile(location)">
              {{ location?.code }}
            </a>
          </div>
        </td>
      </ng-container>

      <!-- Slic -->
      <ng-container matColumnDef="slic">
        <th mat-header-cell *matHeaderCellDef id="slic-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.SLIC"
            [control]="slicData.formControl"
            [maxLength]="30"
            [placeholder]="CONSTANTS.ENTER"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>
        <td mat-cell *matCellDef="let location" headers="slic-headers">
          <div>{{ location?.slic }}</div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="TABLE_COLUMNS; sticky: true"></tr>

      <tr
        mat-row
        *matRowDef="let row; columns: TABLE_COLUMNS; let i = index"
      ></tr>

      <tr class="mat-row" *matNoDataRow>
        <td
          class="mat-cell no-bottom-border no-result-col"
          [attr.colspan]="DISPLAYED_COLS.length"
        >
          <h3 class="no-results">{{ CONSTANTS.NO_SITES }}</h3>
        </td>
      </tr>
    </table>
  </div>
  <!------------------------>
</div>
